import { Link } from "react-router-dom";
import type { Film } from "@/mocks/films";
import { typeLabels } from "@/utils/catalog";
import FavoriteButton from "@/components/base/FavoriteButton";
import { useFavorites } from "@/hooks/useFavorites";

interface FilmCardProps {
  film: Film;
}

export default function FilmCard({ film }: FilmCardProps) {
  const { isFilmFavorite, toggleFilm } = useFavorites();

  return (
    <div className="group relative">
      <Link
        to={`/detail/film/${film.id}`}
        className="block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
      >
        <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
          <img
            src={film.cover}
            alt={`${film.title}封面`}
            title={`${film.title} - 葵司影视资讯`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-700/85 text-background-50 text-xs">
            {typeLabels[film.type]}
          </span>
          <span className="absolute bottom-2 left-2 px-2 py-0.5 rounded-md bg-background-950/70 text-background-50 text-xs flex items-center gap-1">
            <i className="ri-star-fill text-accent-400" />
            {film.rating.toFixed(1)}
          </span>
        </div>
        <div className="p-3">
          <h3 className="font-heading font-bold text-foreground-950 text-base truncate">
            {film.title}
          </h3>
          <p className="mt-1 text-xs text-foreground-600">
            {film.year} · {film.region} · {film.tags.join(" / ")}
          </p>
          <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
            {film.synopsis}
          </p>
        </div>
      </Link>
      <FavoriteButton
        active={isFilmFavorite(film.id)}
        onToggle={() => toggleFilm(film.id)}
        className="absolute top-2 right-2"
      />
    </div>
  );
}